import { notificationSubscriptionFrequencyOptions } from 'src/components/Notifications/Preferences/mock-data';

const UnsubscribeApacSavedSearchByCodePayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};
const ResubscribeApacSavedSearchByCodePayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const Mutation = {
  updateNotificationSubscription: (_: any, args: any) => {
    const { channelCode, productCode, subscribe, frequency } = args.input;
    return {
      __typename: 'NotificationPreference',
      subscriptions: [
        {
          __typename: 'NotificationSubscription',
          id: `${productCode}:${channelCode}`,
          subscribed: subscribe,
          frequency: frequency
            ? {
                value: frequency,
                options: notificationSubscriptionFrequencyOptions,
                __typename: 'NotificationFrequency',
              }
            : null,
        },
      ],
    };
  },
  updateNotificationSubscriptionWithToken: (_: any, args: any) => {
    const { token, subscribe } = args.input;
    if (token === 'error') {
      throw new Error('503 simulated server error');
    }
    return {
      __typename: 'NotificationPreference',
      product: {
        code: 'WRU',
      },
      subscriptions: [
        {
          __typename: 'NotificationSubscription',
          id: `WRU:email`,
          subscribed: subscribe,
          channel: {
            code: 'email',
          },
        },
      ],
    };
  },
  unsubscribeApacSavedSearchByCode: (_: any, args: any) => {
    const { code } = args.input;
    return code === 'error'
      ? {
          __typename: 'UnsubscribeApacSavedSearchByCodeFailure',
          error: {
            message: 'Error Message',
          },
        }
      : { __typename: 'UnsubscribeApacSavedSearchByCodeSuccess' };
  },

  resubscribeApacSavedSearchByCode: (_: any, args: any) => {
    const { code } = args.input;
    return code === 'error'
      ? {
          __typename: 'ResubscribeApacSavedSearchByCodeFailure',
          error: {
            message: 'Error Message',
          },
        }
      : { __typename: 'ResubscribeApacSavedSearchByCodeSuccess' };
  },
};

export {
  UnsubscribeApacSavedSearchByCodePayload,
  ResubscribeApacSavedSearchByCodePayload,
  Mutation,
};
